import React from 'react';
import '../../../../styles/TopRouteItem.css';
import PropTypes from 'prop-types';

const TopRouteItem = ({ data }) => {
  const { heading, listData } = data;
  return (
    <div className="rlRouteItem">
      {heading && <h4>{heading}</h4>}
      {listData && listData.length > 0 && (
        <ul className="rlRouteItem__list">
          {listData.map(({ id, text, link }) => (
            <li key={id}>
              <a href={link}>{text}</a>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

TopRouteItem.propTypes = {
  data: PropTypes.object
};

export default TopRouteItem;
